import React from 'react';
import { MdOutlineToday } from "react-icons/md";
import { NavLink, useLocation } from 'react-router-dom';
import { IoTodaySharp } from "react-icons/io5";
import { IoDocumentsSharp } from "react-icons/io5";

import './layout.css';

const EditAtdLayout = ({ children }) => {
  const location = useLocation();
  
  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <IoTodaySharp className="leave-policy-icon" />
        Today Attendance
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="current-date-link"
                className={({ isActive }) => `nav-link ${isActive || location.pathname === '/edit-atd' ? 'active' : ''}`}
                to="/edit-atd"
              >
                <MdOutlineToday className="nav-icon" /> Current Month
              </NavLink>
            </li>

          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default EditAtdLayout;
